<template>
    <fragment>
        <div class="form-group">
            <div class="row">
                <div class="col-4">
                    <label for="date" class="control-label">{{resource('NewsroomItemCreateModel_Date_DisplayName')}}</label>
                </div>
                <div class="col-8">
                    <date-picker id="date"
                                  v-model="dateValue"
                                 :options="{ 
                                     required: true, 
                                     typeable: false 
                                 }" 
                    />
                </div>

                <template v-if="$v.date.$dirty">
                    <required-error-message
                            class="col-12"
                            
                            v-if="!$v.date.required" 
                            :field-name="resource('NewsroomItemCreateModel_Date_DisplayName')"
                    />
                </template>
            </div>

            <div class="row">
                <div class="col-4">
                    <label for="title" class="control-label">{{resource('NewsroomItemCreateModel_Title_DisplayName')}}</label>
                </div>
                <div class="col-8">
                    <input id="title" type="text" class="form-control" v-model="titleValue" />
                </div>

                <template v-if="$v.title.$dirty">
                    <required-error-message
                            class="col-12"
                            
                            v-if="!$v.title.required" 
                            :field-name="resource('NewsroomItemCreateModel_Title_DisplayName')"
                    />
                    
                    <max-length-exceeded-error-message
                            class="col-12"
                            
                            v-if="!$v.title.maxLength" 
                            :max-length="255" 
                            :field-name="resource('NewsroomItemCreateModel_Title_DisplayName')"
                    />
                </template>
            </div>
        </div>

        <div class="form-group">
            <div class="row">
                <div class="col-12">
                    <label for="content" class="control-label">{{resource('NewsroomItemCreateModel_Content_DisplayName')}}</label>
                </div>

                <div class="col-12">
                    <textarea id="content" class="form-control" rows="6" cols="20" v-model="contentValue"/>
                </div>

                <template v-if="$v.content.$dirty">
                    <required-error-message
                            class="col-12"
                            
                            v-if="!$v.content.required" 
                            :field-name="resource('NewsroomItemCreateModel_Content_DisplayName')"
                    />
                </template>
            </div>
        </div>
    </fragment>
</template>

<script>
    import {required, maxLength} from 'vuelidate/lib/validators'
    
    import resourceMixin from "../../../../Util/Mixins/resources";
    import {validationMixin} from 'vuelidate';
    import dateFormattingMixin from "../../Mixins/date-formatting";

    import DatePicker from "../../../../Components/Util/DatePicker.vue";
    import RequiredErrorMessage from "../../../../Components/Errors/RequiredErrorMessage.vue";
    import MaxLengthExceededErrorMessage from "../../../../Components/Errors/MaxLengthErrorMessage.vue";
    
    export default {
        name: 'newsroom-item-editor',
        components: {
            RequiredErrorMessage,
            MaxLengthExceededErrorMessage,
            DatePicker
        },
        mixins: [dateFormattingMixin, resourceMixin, validationMixin],
        validations: {
            title: {
                required,
                maxLength: maxLength(255)
            },
            date: {
                required
            },
            content: {
                required
            }
        },
        computed: {
            dateValue: {
                get(){
                    return this.parseFormattedDate(this.date);
                },
                set(value){
                    this.$v.date.$touch();
                    this.$emit('update:date', this.formatDate(value));
                }
            },
            titleValue: {
                get(){
                    return this.title;
                },
                set(value){
                    this.$v.title.$touch();
                    this.$emit('update:title', value);
                }
            },
            contentValue: {
                get(){
                    return this.content;
                },
                set(value){
                    this.$v.content.$touch();
                    this.$emit('update:content', value);
                }
            }
        },
        props: {
            date: String,
            title: String,
            content: String
        }
    }
</script>